import { ISectionOption, TOption } from '../types';

export const isSectionOption = (option: TOption): option is ISectionOption => {
  return 'name' in option && 'children' in option;
};
